import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { HOUR_OF_DAY } from '../../fields';
import { HOUR_OF_DAY_VIDEO_REPORT_ID } from './hourDayVideoReportId';

const hourOfDayReportFooterColumnDefinition = [HOUR_OF_DAY].map(createFooterMapper(HOUR_OF_DAY_VIDEO_REPORT_ID));

export default hourOfDayReportFooterColumnDefinition;
